/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TimesheetStatus controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetTimesheetStatusByIdResponse, UpdateTimesheetStatusRequest, GetTimesheetStatusSelectResponse, GetTimesheetStatusesResponse, CreateTimesheetStatusRequest, CreateTimesheetStatusResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TimesheetStatusService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTimesheetStatusById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetStatusByIdResponse>;
    getTimesheetStatusById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetStatusByIdResponse>>;
    getTimesheetStatusById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetStatusByIdResponse>>;
    getTimesheetStatusById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTimesheetStatus(id: number, updateTimesheetStatusRequest: UpdateTimesheetStatusRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTimesheetStatus(id: number, updateTimesheetStatusRequest: UpdateTimesheetStatusRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTimesheetStatus(id: number, updateTimesheetStatusRequest: UpdateTimesheetStatusRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTimesheetStatus(id: number, updateTimesheetStatusRequest: UpdateTimesheetStatusRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTimesheetStatusRequest, requestOptions);
    }

    deleteTimesheetStatus(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTimesheetStatus(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTimesheetStatus(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTimesheetStatus(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getTimesheetStatusSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetStatusSelectResponse>;
    getTimesheetStatusSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetStatusSelectResponse>>;
    getTimesheetStatusSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetStatusSelectResponse>>;
    getTimesheetStatusSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getTimesheetStatuses(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetStatusesResponse>;
    getTimesheetStatuses(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetStatusesResponse>>;
    getTimesheetStatuses(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetStatusesResponse>>;
    getTimesheetStatuses(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTimesheetStatus(createTimesheetStatusRequest: CreateTimesheetStatusRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTimesheetStatusResponse>;
    createTimesheetStatus(createTimesheetStatusRequest: CreateTimesheetStatusRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTimesheetStatusResponse>>;
    createTimesheetStatus(createTimesheetStatusRequest: CreateTimesheetStatusRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTimesheetStatusResponse>>;
    createTimesheetStatus(createTimesheetStatusRequest: CreateTimesheetStatusRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetStatus`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTimesheetStatusRequest, requestOptions);
    }
}
